export default __webpack_public_path__ + "static/media/step3.983202f9.png";